export default {
  status: {},
  countries: [],
  tags: [],
  macros: {}
};